import React from 'react'
import { Form, Field } from 'react-final-form'
import MainLayout from 'layout/MainLayout'
import FinalFormInput from 'components/FinalFormInput'
import { mintNFT } from 'utils/wallet'

const options = ['admin', 'super_user', 'user']

const CreateAccount = () => {
	const createAccount = async (val: any) => {
		mintNFT(val)
	}

	const handleClick = (errors: any, values: any) => {}
	return (
		<MainLayout title='Create An Account'>
			<Form
				onSubmit={(val) => createAccount(val)}
				render={({ handleSubmit, errors, values }) => (
					<form
						className='containers my-20 sm:my-[36px] xl:w-[613px] lg:w-[613px] md:max-w-[613px] flex flex-col'
						onSubmit={handleSubmit}
						autoComplete='off'
					>
						<h4>Create an Account</h4>
						<div className='content grid gap-[12px] my-8'>
							<Field id='title' name='title' placeholder='Title'>
								{(props: any) => <FinalFormInput {...props} required />}
							</Field>
							<Field id='description' name='description' placeholder='Description'>
								{(props: any) => <FinalFormInput {...props} component='textarea' rows={3} required />}
							</Field>
							<Field id='accountId' name='accountId' placeholder='Account Address'>
								{(props: any) => <FinalFormInput {...props} required />}
							</Field>
							<Field id='media' name='media' placeholder='Media Link'>
								{(props: any) => <FinalFormInput {...props} required />}
							</Field>
							<Field id='userType' name='userType' placeholder='User Type'>
								{(props: any) => <FinalFormInput {...props} component='select' options={options} required />}
							</Field>
							<Field id='organization' name='organization' placeholder='Organization'>
								{(props: any) => <FinalFormInput {...props} required />}
							</Field>
						</div>
						<button type='submit' className='high-emphasis ml-auto' onClick={() => handleClick(errors, values)}>
							SUBMIT
						</button>
					</form>
				)}
			/>
		</MainLayout>
	)
}

export default CreateAccount
